import type React from "react";
import { Box, Tabs, Tab, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/Index";

interface FilterTabsProps {
  activeTab: number;
  onTabChange: (event: React.SyntheticEvent, newValue: number) => void;
  searchValue: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({
  activeTab,
  onTabChange,
  searchValue,
  onSearchChange,
}) => {
  const reduxTheme = useSelector((state: RootState) => state.theme);
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      sx={{ mb: 3 }}
    >
      <Tabs
        value={activeTab}
        onChange={onTabChange}
        sx={{
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            minWidth: 80,
            px: 3,
            py: 1.5,
          },
          "& .Mui-selected": {
            backgroundColor: reduxTheme.primary_colors[400],
            color: "white !important",
            borderRadius: 1,
          },
        }}
      >
        <Tab label="All" />
        <Tab label="Premium" />
        <Tab label="Free" />
      </Tabs>

      <TextField
        placeholder="Search"
        value={searchValue}
        onChange={onSearchChange}
        size="small"
        sx={{
          width: 250,
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon color="action" />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
};

export default FilterTabs;
